import { isRef, ref, onMounted, onUnmounted, watch, readonly } from 'vue-demi';
import IMask from 'imask/esm/imask';

function useIMask(props) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      emit = _ref.emit,
      onAccept = _ref.onAccept,
      onComplete = _ref.onComplete;

  props = isRef(props) ? props : ref(props);
  var el = ref();
  var mask = ref();
  var masked = ref();
  var unmasked = ref();
  var typed = ref();
  var $el;
  var $masked;
  var $unmasked;
  var $typed;

  function _onAccept() {
    $typed = typed.value = mask.value.typedValue;
    $unmasked = unmasked.value = mask.value.unmaskedValue;
    $masked = masked.value = mask.value.value;

    if (emit) {
      emit('accept', $masked);
      emit('accept:masked', $masked);
      emit('accept:typed', $typed);
      emit('accept:unmasked', $unmasked);
    }

    if (onAccept) onAccept();
  }

  function _onComplete() {
    if (emit) {
      emit('complete', $masked);
      emit('complete:masked', $masked);
      emit('complete:typed', $typed);
      emit('complete:unmasked', $unmasked);
    }

    if (onComplete) onComplete();
  }

  function _initMask() {
    $el = el.value;
    var $props = props.value;
    if (!$el || !($props !== null && $props !== void 0 && $props.mask)) return;
    mask.value = IMask($el, $props).on('accept', _onAccept).on('complete', _onComplete);

    _onAccept();
  }

  function _destroyMask() {
    if (mask.value) {
      mask.value.destroy();
      mask.value = null;
    }
  }

  onMounted(_initMask);
  onUnmounted(_destroyMask);
  watch(unmasked, function () {
    if (mask.value && $unmasked !== unmasked.value) {
      $unmasked = mask.value.unmaskedValue = unmasked.value;
    }
  });
  watch(masked, function () {
    if (mask.value && $masked !== masked.value) {
      $masked = mask.value.value = masked.value;
    }
  });
  watch(typed, function () {
    if (mask.value) $typed = mask.value.typedValue = typed.value;
  });
  watch([el, props], function () {
    var $newEl = el.value;
    var $props = props.value;
    if (!($props !== null && $props !== void 0 && $props.mask) || $newEl !== $el) _destroyMask();

    if ($newEl) {
      if (!mask.value) {
        _initMask();
      } else {
        mask.value.updateOptions($props);
      }
    }
  });
  return {
    el: el,
    mask: readonly(mask),
    masked: masked,
    unmasked: unmasked,
    typed: typed
  };
}

export { useIMask as default };
